import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import styled, { ThemeProvider as ThemeProviderStyled } from 'styled-components'
import { ThemeProvider } from '@material-ui/core'
import Alert from './components/alert'
import Notification from './components/notification'
import mytheme from './themeMaterial'
import DefineListeners from './components/define_listeners'
import theme from './theme'
import './index.css'

// pages
import CreateItem from './admin/pages/create_item'
import Login from './admin/pages/login'
import MyArticles from './admin/pages/my_articles'
import Orders from './admin/pages/orders'
import Order from './admin/pages/order'
import AdminAppointment from './admin/pages/appointments'

import Home from './user/pages/home'
import Item from './user/pages/item'
import MyCart from './user/pages/my_cart'
import Checkout2 from './user/pages/checkout2'
import admin from './admin/hoc/admin'
import Loading from './components/loading'
import Success from './user/pages/success'
import DINNextLTPro from './fonts/font'
import Promo from './components/promoModal'
import Landing from './user/pages/landing'
import Appointment from './user/pages/appointment'
import ApointmentDetail from './admin/pages/appointmentDetail'

function App () {
  return (
    <ThemeProvider theme={mytheme}>
      <ThemeProviderStyled theme={theme}>
        <DefineListeners>
          <Background>
            <DINNextLTPro />
            <Loading />
            <Notification />
            <Promo />
            <Alert />
            <Switch>
              <Route exact path='/tienda' component={Home} />
              <Route exact path='/' component={Home} />
              <Route exact path='/create-item' component={CreateItem} />
              <Route exact path='/my-articles' component={MyArticles} />
              <Route exact path='/login' component={Login} />
              <Route exact path='/item/:id' component={Item} />
              <Route exact path='/my-cart' component={MyCart} />
              <Route exact path='/checkout' component={Checkout2} />
              <Route exact path='/orders' component={Orders} />
              <Route exact path='/order/:period/:id' component={Order} />
              <Route exact path='/admin' component={admin(props => (<Redirect to='/my-articles' />))} />
              <Route exact path='/success' component={Success} />

              <Route exact path='/landing' component={Landing} />
              <Route exact path='/appointment/:currentid' component={Appointment} />
              <Route exact path='/appointment' component={Appointment} />

              <Route exact path='/admin-appointment' component={AdminAppointment} />
              <Route exact path='/admin-appointment/:id' component={ApointmentDetail} />
            </Switch>
          </Background>
        </DefineListeners>
      </ThemeProviderStyled>
    </ThemeProvider>
  )
}

export default App

const Background = styled('div')`
  background: #f0f2f5;
  min-height: 100vh;
  width: 100vw;
  max-width: 100%;
`
